import i18next from "i18next";
import AuthProvider from "./AuthProvider";
import { NotificationType } from "../enum";
import { setStateFetch } from "../slices/fetchStateSlice";
import { setNotificationMessage } from "../slices/notificationMessageSlice";
import { setNotificationStatus } from "../slices/notificationStatusSlice";
import { store } from "../store";
export default class BaseHttpHandler {
    constructor(baseUrl, withAuth = true, defaultContentType = "application/json", token = null) {
        this._baseUrl = baseUrl;
        this._withAuth = withAuth;
        this._defaultContentType = defaultContentType;
        this._token = token;
    }
    get(url) {
        return this.fetchData(this._baseUrl + url, "GET");
    }
    getFile(url, method, data = null) {
        return this.fetchBlob(this._baseUrl + url, method, data ? JSON.stringify(data) : null);
    }
    put(url, data = null) {
        return this.fetchData(this._baseUrl + url, "PUT", JSON.stringify(data));
    }
    post(url, data = null) {
        return this.fetchData(this._baseUrl + url, "POST", JSON.stringify(data));
    }
    delete(url) {
        return this.fetchData(this._baseUrl + url, "DELETE");
    }
    patch(url, data) {
        return this.fetchData(this._baseUrl + url, "PATCH", JSON.stringify(data));
    }
    refreshToken(url) {
        return fetch(this._baseUrl + url, {
            method: "POST",
            cache: "no-cache",
            redirect: "follow",
            credentials: "include",
        });
    }
    doRequest(url, method, body, accept = "application/json") {
        let contentType = this._defaultContentType;
        if (body) {
            contentType = "application/json";
        }
        let headers = {
            "Content-Type": contentType,
            Connection: "keep-alive",
            //'Authorization': 'Bearer ' + localStorage.getItem('token'),//authManager.getToken(),
            "Accept-Language": "uk",
        };
        let credentialsState = "omit";
        if (this._withAuth) {
            if (this._token) {
                headers["Authorization"] = `Bearer ${this._token}`;
                credentialsState = "include";
            }
            else {
                const token = AuthProvider.getAuthToken();
                if (token) {
                    headers["Authorization"] = `Bearer ${token}`;
                }
            }
        }
        const fetchState = store.getState().fetchState.value;
        store.dispatch(setStateFetch(fetchState + 1));
        return fetch(url, {
            method: method,
            //cache: 'no-cache',
            credentials: credentialsState,
            headers: headers,
            //redirect: 'follow',
            mode: "cors",
            body: body,
        })
            .then(async (response) => {
            if (response.ok) {
                //const json = (await response.json()) as ApiResponseModel;
                if (accept == "application/json") {
                    return response.json();
                }
                if (accept == "application/vnd.ms-excel" ||
                    accept == "application/octet-stream") {
                    return response.blob();
                }
                return response.text();
            }
            if (response.status == 401) {
                window.location.href = "/login";
                AuthProvider.setAuthToken({ token: null, expiration: null });
                /* userService.refreshToken().then((data) => {
                               console.log(url);
                               authManager.saveToken(data.data.accessToken);
                           })
                               .catch((err) => {
                                   //authManager.deleteToken();
                               });*/
            }
            const body = await response.json();
            throw new Error(body.message);
        })
            .catch((err) => {
            if (err.toString().toLowerCase().indexOf(" to fetch") !== -1) {
                store.dispatch(setNotificationMessage({
                    message: i18next.t("errors.noServerConnection"),
                    type: NotificationType.Error,
                }));
            }
            else {
                store.dispatch(setNotificationMessage({
                    message: err.message,
                    type: NotificationType.Error,
                }));
            }
            store.dispatch(setNotificationStatus(true));
            throw err;
        })
            .finally(() => {
            const fetchState = store.getState().fetchState.value;
            store.dispatch(setStateFetch(fetchState - 1));
        });
    }
    fetchBlob(url, method, body) {
        return this.doRequest(url, method, body, "application/vnd.ms-excel");
    }
}
